import { FadeUp } from './Reveal'
import { getFounders } from '../data'
import { useLocale, useT } from '../i18n/locale.jsx'

// Fondatorii ca intrări de dicționar: inițială-dropcap honey + nume Fraunces,
// linie de dicționar mono, glose în Fraunces italic cu eticheta mono honey.
export default function Founders() {
  const locale = useLocale()
  const t = useT().founders
  const founders = getFounders(locale)
  return (
    <section data-theme="light" className="px-5 py-28 text-ink md:px-10 md:py-40">
      <p className="eyebrow mb-14">{t.eyebrow} ✦</p>

      <div className="mx-auto grid max-w-site gap-14 md:grid-cols-2 md:gap-x-16 md:gap-y-20">
        {founders.map((f, i) => (
          <FadeUp key={f.name} delay={i * 0.1}>
            <article className="flex items-start gap-4 md:gap-6">
              {/* inițială-dropcap honey */}
              <span className="display select-none text-7xl leading-none text-honey md:text-8xl" aria-hidden>
                {f.name[0]}.
              </span>

              <div className="flex-1 pt-1">
                <h3 className="display text-4xl leading-[0.95] md:text-5xl">{f.name}</h3>
                <p className="mt-2 font-mono text-[12px] lowercase tracking-wide text-ink-soft">{f.entry}</p>

                <div className="mt-7 flex flex-col gap-5">
                  {f.glosses.map(([label, text]) => (
                    <p key={label} className="font-display text-[17px] italic leading-relaxed text-ink-soft">
                      <span className="font-mono text-[11px] not-italic lowercase tracking-wide text-ink">
                        {label} :
                      </span>{' '}
                      {text}
                    </p>
                  ))}
                </div>

                <a
                  href={f.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex min-h-[44px] items-center gap-1.5 font-mono text-xs lowercase tracking-[0.06em] text-ink underline underline-offset-4 decoration-ink/30 transition-colors duration-300 ease-quint hover:decoration-honey"
                >
                  {t.connect} <span>↗</span>
                </a>
              </div>
            </article>
          </FadeUp>
        ))}
      </div>
    </section>
  )
}
